<template>
  <div>
    <styled-field-dropdown
      :dropright="true"
      :options="teamDropdownOptions"
      @change="onTeamSettingsSelection"
    >
      <slot />
    </styled-field-dropdown>
    <manage-team-members
      v-if="showManageTeamMembers"
      v-model="showManageTeamMembers"
      :org-id="orgId"
      :team-id="team.id"
    />
    <manage-team
      v-model="showManageTeam"
      :team-id="team.id"
      :org-id="orgId"
      :sub-org-id="subOrgId"
      :group-type="team.isOrgLike ? GROUP_TYPE.CHILDORG : GROUP_TYPE.TEAM"
      :handle-navigation-on-delete="true"
      @team-archived="$emit('team-archived')"
      @team-unarchived="$emit('team-unarchived')"
      v-if="showManageTeam"
    />
    <confirm-dialog
      ref="archiveModal"
      title="Are you sure you want to archive this team?"
      @ok="archiveCurrentTeam"
      ok-title="Yes, archive"
      cancel-title="No, I changed my mind"
    >
      You can always re-open a closed team
    </confirm-dialog>
    <confirm-dialog
      title="Restore?"
      ref="restoreModal"
      @ok="restoreCurrentTeam"
      ok-title="Yes, restore"
      cancel-title="No, I changed my mind"
      hide-header-close
    >
      We'll move it to the same Org it belonged to
    </confirm-dialog>
  </div>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import StyledFieldDropdown from '@/components/form/dropdown/StyledFieldDropdown.vue'
import ManageTeam from '@/components/ManageTeam.vue'
import ManageTeamMembers from '@/components/ManageTeamMembers.vue'
import { GROUP_MAP, GROUP_TYPE } from '@/constants/entities'
import EventBus from '@/EventBus'
import TeamMixin from '@/mixins/TeamMixin'

/**
 * This gives a dropdown for Team settings
 * User can update team info, manage team members, archive team from this menu
 */
export default {
  name: 'TeamSettings',
  components: { ConfirmDialog, ManageTeam, ManageTeamMembers, StyledFieldDropdown },
  props: ['team'],
  mixins: [TeamMixin],
  data() {
    return {
      showManageTeamMembers: false,
      showManageTeam: false,
      GROUP_TYPE
    }
  },
  computed: {
    orgId() {
      return this.team.organizationId
    },
    subOrgId() {
      return this.getClosestOrgLikeTeamId(this.team.id)
    },
    teamDropdownOptions() {
      const team = this.team || {}
      const entity = this.team.isOrgLike
        ? GROUP_MAP[GROUP_TYPE.CHILDORG].name
        : GROUP_MAP[GROUP_TYPE.TEAM].name
      return [
        { label: `${entity} Settings`, id: 'manageTeam' },
        { label: `${entity} Members`, id: 'manageTeamMembers' },
        team.isArchived
          ? { label: `Restore ${entity}`, id: 'unarchiveTeam' }
          : { label: `Archive ${entity}`, id: 'archiveTeam' }
      ]
    }
  },
  methods: {
    onTeamSettingsSelection({ id: selectionType }) {
      if (selectionType === 'manageTeamMembers') {
        this.showManageTeamMembers = true
      } else if (selectionType === 'manageTeam') {
        this.showManageTeam = true
      } else if (selectionType === 'archiveTeam') {
        this.$refs.archiveModal.$refs.dialog.show()
      } else if (selectionType === 'unarchiveTeam') {
        this.$refs.restoreModal.$refs.dialog.show()
      }
    },
    async archiveCurrentTeam() {
      EventBus.$emit('ADD_TOAST', { message: 'Archiving team. It may take some time' })
      const inArchived = await this.performTeamArchival({
        action: 'archive',
        teamId: this.team.id,
        orgId: this.orgId
      })
      if (inArchived) {
        this.$emit('team-archived')
      }
    },
    async restoreCurrentTeam() {
      EventBus.$emit('ADD_TOAST', { message: 'Restoring team. It may take some time' })
      const inUnarchived = await this.performTeamArchival({
        action: 'unarchive',
        teamId: this.team.id,
        orgId: this.orgId
      })
      if (inUnarchived) {
        this.$emit('team-unarchived')
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
